<div class="content-area">
  <div class="reports-outer kpi-report-outer">
    <p-tabView class="tab-outer kpi-report-outer__tabs">
      <div class="title-block">
        <h1>{{ title }}</h1>
      </div>

      <p-tabPanel header="Reports">
        <ng-template pTemplate="header">
          <span href="javascript:void(0)" class="select-kpi kpi-dashboard" *ngIf="kpiReport"
            (click)="setReportTitle(false)">
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M5.75 10C6.34674 10 6.91903 10.2371 7.34099 10.659C7.76295 11.081 8 11.6533 8 12.25V15.75C8 16.3467 7.76295 16.919 7.34099 17.341C6.91903 17.7629 6.34674 18 5.75 18H2.25C1.65326 18 1.08097 17.7629 0.65901 17.341C0.237053 16.919 0 16.3467 0 15.75V12.25C0 11.6533 0.237053 11.081 0.65901 10.659C1.08097 10.2371 1.65326 10 2.25 10H5.75ZM15.75 10C16.3467 10 16.919 10.2371 17.341 10.659C17.7629 11.081 18 11.6533 18 12.25V15.75C18 16.3467 17.7629 16.919 17.341 17.341C16.919 17.7629 16.3467 18 15.75 18H12.25C11.6533 18 11.081 17.7629 10.659 17.341C10.2371 16.919 10 16.3467 10 15.75V12.25C10 11.6533 10.2371 11.081 10.659 10.659C11.081 10.2371 11.6533 10 12.25 10H15.75ZM5.75 11.5H2.25C2.05109 11.5 1.86032 11.579 1.71967 11.7197C1.57902 11.8603 1.5 12.0511 1.5 12.25V15.75C1.5 16.164 1.836 16.5 2.25 16.5H5.75C5.94891 16.5 6.13968 16.421 6.28033 16.2803C6.42098 16.1397 6.5 15.9489 6.5 15.75V12.25C6.5 12.0511 6.42098 11.8603 6.28033 11.7197C6.13968 11.579 5.94891 11.5 5.75 11.5ZM15.75 11.5H12.25C12.0511 11.5 11.8603 11.579 11.7197 11.7197C11.579 11.8603 11.5 12.0511 11.5 12.25V15.75C11.5 16.164 11.836 16.5 12.25 16.5H15.75C15.9489 16.5 16.1397 16.421 16.2803 16.2803C16.421 16.1397 16.5 15.9489 16.5 15.75V12.25C16.5 12.0511 16.421 11.8603 16.2803 11.7197C16.1397 11.579 15.9489 11.5 15.75 11.5ZM5.75 0C6.34674 0 6.91903 0.237053 7.34099 0.65901C7.76295 1.08097 8 1.65326 8 2.25V5.75C8 6.34674 7.76295 6.91903 7.34099 7.34099C6.91903 7.76295 6.34674 8 5.75 8H2.25C1.65326 8 1.08097 7.76295 0.65901 7.34099C0.237053 6.91903 0 6.34674 0 5.75V2.25C0 1.65326 0.237053 1.08097 0.65901 0.65901C1.08097 0.237053 1.65326 0 2.25 0H5.75ZM15.75 0C16.3467 0 16.919 0.237053 17.341 0.65901C17.7629 1.08097 18 1.65326 18 2.25V5.75C18 6.34674 17.7629 6.91903 17.341 7.34099C16.919 7.76295 16.3467 8 15.75 8H12.25C11.6533 8 11.081 7.76295 10.659 7.34099C10.2371 6.91903 10 6.34674 10 5.75V2.25C10 1.65326 10.2371 1.08097 10.659 0.65901C11.081 0.237053 11.6533 0 12.25 0H15.75ZM5.75 1.5H2.25C2.05109 1.5 1.86032 1.57902 1.71967 1.71967C1.57902 1.86032 1.5 2.05109 1.5 2.25V5.75C1.5 6.164 1.836 6.5 2.25 6.5H5.75C5.94891 6.5 6.13968 6.42098 6.28033 6.28033C6.42098 6.13968 6.5 5.94891 6.5 5.75V2.25C6.5 2.05109 6.42098 1.86032 6.28033 1.71967C6.13968 1.57902 5.94891 1.5 5.75 1.5ZM15.75 1.5H12.25C12.0511 1.5 11.8603 1.57902 11.7197 1.71967C11.579 1.86032 11.5 2.05109 11.5 2.25V5.75C11.5 6.164 11.836 6.5 12.25 6.5H15.75C15.9489 6.5 16.1397 6.42098 16.2803 6.28033C16.421 6.13968 16.5 5.94891 16.5 5.75V2.25C16.5 2.05109 16.421 1.86032 16.2803 1.71967C16.1397 1.57902 15.9489 1.5 15.75 1.5Z"
                fill="#6F64A7" />
            </svg>
          </span>
        </ng-template>
        <ng-template pTemplate="content">
          <div class="reports-main">
            <div class="box">
              <a (click)="scheduledAppointmentReport()" class="box__link">
                <span class="box__link__text-label">Scheduled Appointments</span>
              </a>
            </div>
            <div class="box">
              <a (click)="rescheduledAppointmentReport()" class="box__link">
                <span class="box__link__text-label">Rescheduled Appointments</span>
              </a>
            </div>
            <div class="box">
              <a (click)="cancelledAppointmentReport()" class="box__link">
                <span class="box__link__text-label">Cancelled Appointments</span>
              </a>
            </div>
            <div class="box">
              <a (click)="noShowAppointmentReport()" class="box__link">
                <span class="box__link__text-label">No Show Appointments</span>
              </a>
            </div>
            <div class="box">
              <a (click)="voidedAppointmentReport()" class="box__link">
                <span class="box__link__text-label">Void Appointments</span>
              </a>
            </div>
            <div class="box">
              <a (click)="awaitingAppointmentReport()" class="box__link">
                <span class="box__link__text-label">Awaiting Appointments</span>
              </a>
            </div>
            <div class="box">
              <a (click)="completedAppointmentReport()" class="box__link">
                <span class="box__link__text-label">Completed Appointments</span>
              </a>
            </div>
            <div class="box">
              <a (click)="unreconciledAppointmentReport()" class="box__link">
                <span class="box__link__text-label">Unreconciled Appointments</span>
              </a>
            </div>
            <div class="box">
              <a (click)="bookedAppointmentReport()" class="box__link">
                <span class="box__link__text-label">Booked Appointments</span>
              </a>
            </div>
            <div class="box">
              <a (click)="reconciledAppointmentReport()" class="box__link">
                <span class="box__link__text-label">Reconciled Appointments</span>
              </a>
            </div>
            <div class="box">
              <a (click)="saleOrderHistoryReport()" class="box__link">
                <span class="box__link__text-label">Export Transaction Data</span>
              </a>
            </div>
            <div class="box">
              <a (click)="voiceCallLogReport()" class="box__link">
                <span class="box__link__text-label">Call Recording Logs</span>
              </a>
            </div>
            <div class="box">
              <a [routerLink]="['/admin/reports/time-slot-availability-summary']" class="box__link">
                <span class="box__link__text-label">Time Slot Availability Summary</span>
              </a>
            </div>
            <div *ngIf="isVisibleBrightreeSalesOrderHistory" class="box">
              <a [routerLink]="['/admin/reports/app-autosync-salesorder']" class="box__link">
                <span class="box__link__text-label">Brightree API Process Status</span>
              </a>
            </div>
            <div class="box">
              <a [routerLink]="['/admin/reports/payment-transaction-logs']" class="box__link">
                <span class="box__link__text-label">Payment Transaction Logs</span>
              </a>
            </div>
          </div>
        </ng-template>
      </p-tabPanel>
      <p-tabPanel header="KPI Reports">
        <ng-template pTemplate="header">
          <span href="javascript:void(0)" class="select-kpi kpi-report" *ngIf="kpiReport"
            (click)="setReportTitle(true)">
            <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M0.900003 16C0.645003 16 0.431103 15.9147 0.258303 15.744C0.085503 15.5733 -0.000596886 15.3624 3.11419e-06 15.1111C3.11419e-06 14.8593 0.0864032 14.648 0.259203 14.4773C0.432003 14.3067 0.645603 14.2216 0.900003 14.2222H17.1C17.355 14.2222 17.5689 14.3076 17.7417 14.4782C17.9145 14.6489 18.0006 14.8598 18 15.1111C18 15.363 17.9136 15.5742 17.7408 15.7449C17.568 15.9156 17.3544 16.0006 17.1 16H0.900003ZM2.25 13.3333C1.875 13.3333 1.5561 13.2036 1.2933 12.944C1.0305 12.6844 0.899403 12.3698 0.900003 12V8.44444C0.900003 8.07407 1.0314 7.75911 1.2942 7.49956C1.557 7.24 1.8756 7.11052 2.25 7.11111C2.625 7.11111 2.9439 7.24089 3.2067 7.50044C3.4695 7.76 3.6006 8.07467 3.6 8.44444V12C3.6 12.3704 3.4686 12.6853 3.2058 12.9449C2.943 13.2044 2.6244 13.3339 2.25 13.3333ZM6.75 13.3333C6.375 13.3333 6.0561 13.2036 5.7933 12.944C5.5305 12.6844 5.3994 12.3698 5.4 12V4C5.4 3.62963 5.5314 3.31467 5.7942 3.05511C6.057 2.79556 6.3756 2.66608 6.75 2.66667C7.125 2.66667 7.4439 2.79645 7.7067 3.056C7.9695 3.31556 8.1006 3.63022 8.1 4V12C8.1 12.3704 7.9686 12.6853 7.7058 12.9449C7.443 13.2044 7.1244 13.3339 6.75 13.3333ZM11.25 13.3333C10.875 13.3333 10.5561 13.2036 10.2933 12.944C10.0305 12.6844 9.8994 12.3698 9.9 12V6.66667C9.9 6.2963 10.0314 5.98133 10.2942 5.72178C10.557 5.46222 10.8756 5.33274 11.25 5.33333C11.625 5.33333 11.9439 5.46311 12.2067 5.72267C12.4695 5.98222 12.6006 6.29689 12.6 6.66667V12C12.6 12.3704 12.4686 12.6853 12.2058 12.9449C11.943 13.2044 11.6244 13.3339 11.25 13.3333ZM15.75 13.3333C15.375 13.3333 15.0561 13.2036 14.7933 12.944C14.5305 12.6844 14.3994 12.3698 14.4 12V1.33333C14.4 0.962965 14.5314 0.648002 14.7942 0.388446C15.057 0.128891 15.3756 -0.000590568 15.75 2.0248e-06C16.125 2.0248e-06 16.4439 0.12978 16.7067 0.389335C16.9695 0.648891 17.1006 0.963557 17.1 1.33333V12C17.1 12.3704 16.9686 12.6853 16.7058 12.9449C16.443 13.2044 16.1244 13.3339 15.75 13.3333Z"
                fill="#373737" />
            </svg>
          </span>
          <span class="pro-icon" *ngIf="!IsKPIAccess">
            <svg width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M1.7778 11.25L0 0.9375L4.8889 5.625L8 0L11.1111 5.625L16 0.9375L14.2222 11.25H1.7778ZM14.2222 14.0625C14.2222 14.625 13.8667 15 13.3333 15H2.6667C2.1333 15 1.7778 14.625 1.7778 14.0625V13.125H14.2222V14.0625Z"
                fill="#FFA800" />
            </svg>
          </span>
        </ng-template>
        <ng-template pTemplate="content">
<div class="reports-container">
          <div class="kpi-content-outer">
            <div class="kpi-content-outer__default" *ngIf="!IsKPIAccess">

              <div class="demo-graph-image__requst-block">
                <p>You don’t have the permission to access the Premium KPI Reports feature.</p>
                <a href="javascript:void(0)" class="btn btn--secondary" (click)="RequesttheAccess()">
                  <svg width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M1.7778 11.25L0 0.9375L4.8889 5.625L8 0L11.1111 5.625L16 0.9375L14.2222 11.25H1.7778ZM14.2222 14.0625C14.2222 14.625 13.8667 15 13.3333 15H2.6667C2.1333 15 1.7778 14.625 1.7778 14.0625V13.125H14.2222V14.0625Z"
                      fill="#FFA800" />
                  </svg>
                  Request the Access of Premium KPI Reports
                </a>
              </div>
            </div>

            <div class="kpi-content-outer__kpi-report-block-outer" *ngIf="IsKPIAccess">
              <app-kpi-report [refreshGrid]="refreshGrid"></app-kpi-report>
            </div>
          </div>
</div>
        </ng-template>
      </p-tabPanel>
    </p-tabView>
  </div>
</div>

<div class="loader-block" *ngIf="loading">
  <p-progressSpinner [style]="{ width: '50px', height: '50px' }" strokeWidth="8" fill="#ffffff" animationDuration=".8s">
  </p-progressSpinner>
</div>